import { NgZone } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "./sse.service";
import * as i2 from "@angular/common/http";
var AiservicesService = /** @class */ (function () {
    function AiservicesService(_zone, _sseService, http) {
        this._zone = _zone;
        this._sseService = _sseService;
        this.http = http;
    }
    AiservicesService.prototype.getMaxOilTime = function (deviceid) {
        return this.http.post("getMaxOilTime", deviceid);
    };
    AiservicesService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AiservicesService_Factory() { return new AiservicesService(i0.ɵɵinject(i0.NgZone), i0.ɵɵinject(i1.SseService), i0.ɵɵinject(i2.HttpClient)); }, token: AiservicesService, providedIn: "root" });
    return AiservicesService;
}());
export { AiservicesService };
